module.exports = __webpack_public_path__ + "static/img/Emmanuel-Babeau_2017-18.d0f6625.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Emmanuel-Babeau_2017-18.jpg
// module id = ITlY
// module chunks = 0